let visibleMobileConsole = false;
const { DEV, MODE } = import.meta.env;

export const isProduction = MODE === 'production';
export const isStaging = MODE === 'staging' && !DEV;
export const isDEV = () => DEV || location.href.indexOf('gtm') > -1;

export const showConsole = (productionAllowed = false) => {
  if (visibleMobileConsole || !(isDEV || isStaging || productionAllowed)) return;
  const script = document.createElement('script');

  script.src =
    'https://cdnjs.cloudflare.com/ajax/libs/eruda/3.4.1/eruda.min.js';

  script.onload = () => {
    (window as Application).eruda?.init();
    (window as Application).eruda?.add(function (eruda: any) {
      class Test extends eruda.Tool {
          constructor() {
              super()
              this.name = 'Custom CSS Tool'
              this.style = eruda.util.evalCss('.eruda-container { z-index: 2147483048 !important; }');
          }
          init($el: HTMLElement) {
            super.init($el);
          }
          destroy() {
              super.destroy();
              eruda.util.evalCss.remove(this.style);
          }
      }

      return new Test();
  })}
  document.head.append(script);
  visibleMobileConsole = true;
};
